import { render, staticRenderFns } from "./create-sign.vue?vue&type=template&id=4a56b6ce&scoped=true&"
import script from "./create-sign.vue?vue&type=script&lang=js&"
export * from "./create-sign.vue?vue&type=script&lang=js&"
import style0 from "./create-sign.vue?vue&type=style&index=0&id=4a56b6ce&prod&lang=scss&scoped=true&"
import style1 from "./create-sign.vue?vue&type=style&index=1&id=4a56b6ce&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56b6ce",
  null
  
)

export default component.exports